<template>
  <div class="registration_form_view">
    <div class="query_wapper">
      <div class="query_items">
        <el-button-group>
          <el-button
            @click="selectType(1)"
            :class="switchType === 1?'select':'normal'"
            style="width:100px"
          >报名表</el-button>
          <el-button @click="selectType(2)" :class="switchType === 2?'select':'normal'">运动员照片</el-button>
        </el-button-group>
        <el-select
          style="margin:0 20px;"
          v-model="query.year"
          @change="getMatch"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="(item,index) in yearLists"
            :value="item.value"
            :label="item.label"
            :key="index"
          ></el-option>
        </el-select>
        <el-select
          v-model="query.matchName"
          :popper-append-to-body="false"
          @change="$event=>getSignDetail($event)"
        >
          <el-option
            v-for="(item,index) in matchList"
            :key="index"
            :value="item.id"
            :label="item.matchName"
          ></el-option>
        </el-select>
      </div>
      <div class="query_items" v-if="isShowData">
        <el-button type="warning" style="width:90px;margin:0 10px 0 20px" @click="print">打印</el-button>
        <!-- <el-button type="primary" style="width:90px" @click="downExcel">下载</el-button> -->
      </div>
    </div>
    <template v-if="isShowData">
      <div v-if="switchType === 1" class="table_box">
        <p class="head_title">单位名称：{{userInfo.schoolName}}</p>
        <p class="head_title" style="margin:10px 0;">领队：{{details.leaderName}}</p>
        <p class="head_title">教练：{{getCoachName}}</p>
        <table
          style="border:1px solid #ddd;margin-top:20px"
          border="0"
          cellspacing="0"
          cellpadding="0"
        >
          <thead>
            <template v-for="(item,index) in columns">
              <!-- && item.key !== 'ws4' && item.key !== 'ws5' && item.key !== 'ws6' && item.key !== 'ws7' -->
              <th
                v-if="item.key !== 'ws1' && item.key !== 'ws2' && item.key !== 'ws3'"
                :key="index"
                :style="{width:item.width + 'px'}"
                class="ths big_title"
              >
                <div class="cell">{{item.title}}</div>
              </th>
              <th
                class="ths"
                v-else-if="item.key == 'ws1'"
                :key="index"
                :style="{width:item.width + 'px'}"
              >
                <span class="big_title">自选拳术（单项）</span>
                <!-- <span class="small_title">（单项）</span> -->
              </th>
              <th
                class="ths"
                v-else-if="item.key == 'ws2'"
                :key="index"
                :style="{width:item.width + 'px'}"
              >
                <span class="big_title">自选短器械（单项）</span>
                <!-- <span class="small_title">（单项）</span> -->
              </th>
              <th
                class="ths"
                v-else-if="item.key == 'ws3'"
                :key="index"
                :style="{width:item.width + 'px'}"
              >
                <span class="big_title">自选长器械（单项）</span>
                <!-- <span class="small_title">（单项）</span> -->
              </th>
              <!-- <th
                class="ths"
                v-else-if="item.key == 'ws4'"
                :key="index"
                :style="{width:item.width + 'px'}"
              >
                <span class="big_title">太极剑</span>
                <span class="small_title">（单项）</span>
              </th>
              <template v-else-if="item.key == 'ws5'">
                <th class="ths" :key="index" :style="{width:item.width + 'px'}">
                  <p>
                    <span class="big_title">南拳</span>
                    <span class="small_title">（单项）</span>
                  </p>
                  <span class="small_title">（备注项目）</span>
                </th>
              </template>
              <template v-else-if="item.key == 'ws6'">
                <th class="ths" :key="index" :style="{width:item.width + 'px'}">
                  <p>
                    <span class="big_title">南刀</span>
                    <span class="small_title">（单项）</span>
                  </p>
                  <span class="small_title">（备注项目）</span>
                </th>
              </template>

              <th
                class="ths"
                v-else-if="item.key == 'ws7'"
                :key="index"
                :style="{width:item.width + 'px'}"
              >
                <p class="big_title">南棍</p>
                <span class="small_title">（单项）</span>
              </th> -->
              <!-- <th
                class="ths"
                v-else-if="item.key == 'ws8'"
                :key="index"
                :style="{width:item.width + 'px'}"
              >
                <p class="big_title">品势：团体</p>
                <span class="small_title">（多人）</span>
              </th> -->
            </template>
          </thead>
          <tbody>
            <tr v-for="(item,index) in details.athleteList" :key=" index">
              <td style="text-align:center;color:#444;">
                <div class="cell">{{index + 1}}</div>
              </td>
              <template v-for="(temp,num) in columns.slice(1)">
                <td style="text-align:center;color:#444;" :key="num + '_' + index">
                  <div class="cell">{{getKey(temp.key,index)}}</div>
                </td>
              </template>
            </tr>
          </tbody>
        </table>
        <div
          v-if="details.state === 0"
          style="height:150px;color:#444;padding:20px;border:1px solid #ddd;border-top:none"
        >
          <section
            style="display:flex;height:100%;
            flex-direction:column;align-items:center;justify-content:center"
          >
            <p style="font-size:24px">报名未提交</p>
            <el-button
              v-if="userInfo.type === 4"
              style="margin:20px 0 0 0"
              type="primary"
              @click="moveSubmit"
            >前往提交</el-button>
          </section>
        </div>
        <div
          v-else
          :style="{height:details.state == 2 && userInfo.type === 4?'150px':'100px'}"
          style="width:100%;color:#444;padding:10px 20px;border:1px solid #ddd;border-top:none"
        >
          <p style="font-size:14px;">体育部意见：</p>
          <p
            style="font-size:24px;text-align:center;margin-top:10px;"
          >{{details.state === 1?'待审核':details.state === 2?'已驳回':'同意'}}</p>

          <div
            style="margin:20px 0 0 0;display:flex;justify-content:center;width:100%"
            v-if="switchType === 1 && details.state === 2 && userInfo.type === 4"
          >
            <el-button type="primary" @click="moveSubmit">前往修改</el-button>
          </div>
        </div>
      </div>
      <athletesPhoto v-else :details="details"></athletesPhoto>
      <div id="prints">
        <div style="page-break-after:always;">
          <h2 class="match_title">{{currentProject.matchName}}</h2>
          <p class="head_title">单位名称：{{userInfo.schoolName}}</p>
          <p class="head_title distance" style="margin:10px 0;">领队：{{details.leaderName}}</p>
          <p class="head_title">教练：{{getCoachName}}</p>
          <table
            v-for="t in getTableNum"
            :style="{marginTop:t!== 1?'80px':''}"
            style="border:1px solid #ddd;margin-top:20px;width:100%;page-break-after:always"
            border="0"
            :key="t"
            cellspacing="0"
            cellpadding="0"
          >
            <thead>
              <template v-for="(item,index) in columns">
                <!-- && item.key !== 'ws4' && item.key !== 'ws5' && item.key !== 'ws6' && item.key !== 'ws7' -->
                <th
                  v-if="item.key !== 'ws1' && item.key !== 'ws2' && item.key !== 'ws3'"
                  :key="index"
                  :style="{width:item.width + 'px',borderRight:index == columns.length - 1?'none!important':'1px solid #999'}"
                  class="ths big_title"
                >
                  <div class="cell">{{item.title}}</div>
                </th>
                <th class="ths" v-else-if="item.key == 'ws1'" :key="index" style="width:90px">
                  <p class="big_title">自选拳术</p>
                  <span class="small_title">（单项）</span>
                </th>
                <th class="ths" v-else-if="item.key == 'ws2'" :key="index" style="width:90px">
                  <p class="big_title">自选短器械</p>
                  <span class="small_title">（单项）</span>
                </th>
                <th class="ths" v-else-if="item.key == 'ws3'" :key="index" style="width:90px">
                  <p class="big_title">自选长器械</p>
                  <span class="small_title">（单项）</span>
                </th>
                <!-- <th class="ths" v-else-if="item.key == 'ws4'" :key="index" style="width:90px">
                  <p class="big_title">42式太极剑</p>
                  <span class="small_title">（单项）</span>
                </th>
                <template v-else-if="item.key == 'ws5'">
                  <th class="ths" :key="index" style="width:110px">
                    <p>
                      <span class="big_title">南拳</span>
                      <span class="small_title">（单项）</span>
                    </p>
                    <span class="small_title">（备注项目）</span>
                  </th>
                </template>
                <template v-else-if="item.key == 'ws6'">
                  <th class="ths" :key="index" style="width:110px">
                    <p>
                      <span class="big_title">南刀</span>
                      <span class="small_title">（单项）</span>
                    </p>
                    <span class="small_title">（备注项目）</span>
                  </th>
                </template>
                <th class="ths" v-else-if="item.key == 'ws7'" :key="index" style="width:90px">
                  <p class="big_title">南棍</p>
                  <span class="small_title">（单项）</span>
                </th> -->
              </template>
            </thead>
            <tbody>
              <tr
                v-for="(item,index) in details.athleteList.slice((t -1) * 18,t* 18)"
                :key=" index"
              >
                <td style="text-align:center;color:#444;border-right:1px solid #999">
                  <div class="cell">{{index + 1}}</div>
                </td>
                <template v-for="(temp,num) in columns.slice(1)">
                  <td
                    :style="{borderRight:num == columns.length - 2?'none!important':'1px solid #999'}"
                    style="text-align:center;color:#444;"
                    :key="num + '_' + index"
                  >
                    <div class="cell">{{getKey(temp.key,index)}}</div>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
        <athletesPhoto :details="details"></athletesPhoto>
      </div>
    </template>
    <template v-else>
      <div style="padding:160px 0 0 250px">
        <img src="../../assets/img/signUp/no_data.png" alt />
      </div>
    </template>
  </div>
</template>
<script>
import { baseUrl } from "@/utils/config";
import { getSession } from "@/utils/storage";
import { getSignListBySchool, signDetail } from "@/api/sign-up-match";
import { selectiveYear } from "@/common/js/mixins";
import athletesPhoto from "./components/athletes-photo";
import { getCoachList } from "@/api/athletes.js";
export default {
  mixins: [selectiveYear],
  components: {
    athletesPhoto
  },
  data() {
    return {
      switchType: 1,
      query: {
        year: "",
        matchName: ""
      },
      currentProject: "",
      userInfo: JSON.parse(getSession("userInfo")),
      matchList: [],
      coachList: [],
      columns: [
        {
          title: "序号",
          width: 60
        },
        {
          title: "组别",
          width: 80,
          key: "groupId"
        },
        {
          title: "性别",
          width: 80,
          key: "genderText"
        },
        {
          title: "姓名",
          width: 140,
          key: "athleteName"
        },
        {
          title: "身份证号码",
          width: 200,
          key: "idCard"
        },
        {
          title: "",
          width: 160,
          key: "ws1"
        },
        {
          title: "",
          width: 160,
          key: "ws2"
        },
        {
          title: "",
          width: 160,
          key: "ws3"
        },
        // {
        //   title: "",
        //   width: 140,
        //   key: "ws4"
        // },
        // {
        //   title: "",
        //   width: 140,
        //   key: "ws5"
        // },
        // {
        //   title: "",
        //   width: 140,
        //   key: "ws6"
        // },
        // {
        //   title: "",
        //   width: 100,
        //   key: "ws7"
        // },
        // {
        //   title: "",
        //   width: 100,
        //   key: "ws8"
        // },
        {
          title: "备注",
          key: "remarks",
          width: 140
        }
      ],
      details: {},
      isShowData: true
    };
  },
  computed: {
    getCoachName() {
      let coach = this.details.coachIds ? this.details.coachIds.split(",") : [];
      let arr = [];
      this.coachList.filter(item => {
        if (coach.includes(item.id)) {
          arr.push(item.name);
        }
      });
      return arr.join(",");
    },
    getKey() {
      return (key, index) => {
        let keys = "";
        this.columns.filter(item => {
          if (item.key === key) {
            switch (key) {
              case "ws1":
                keys = this.details.athleteList[index].projectJson[item.key];
                break;
              case "ws2":
                keys = this.details.athleteList[index].projectJson[item.key];
                break;
              case "ws3":
                keys = this.details.athleteList[index].projectJson[item.key];
                break;
              // case "ws4":
              //   keys = this.details.athleteList[index].projectJson[item.key];
              //   break;
              // case "ws5":
              //   keys = this.details.athleteList[index].projectJson[item.key];
              //   break;
              // case "ws6":
              //   keys = this.details.athleteList[index].projectJson[item.key];
              //   break;
              // case "ws7":
              //   keys = this.details.athleteList[index].projectJson[item.key];
              //   break;
              // case "ws8":
              //   keys = this.details.athleteList[index].projectJson[item.key];
              //   break;
              case "groupId":
                keys =
                  this.details.athleteList[index][item.key] == 1
                    ? "甲组"
                    : this.details.athleteList[index][item.key] == 2
                    ? "乙组"
                    : this.details.athleteList[index][item.key] == 4
                    ? "丙组"
                    : "丁组";
                    
                break;
              default:
                keys = this.details.athleteList[index][item.key];
                break;
            }
          }
        });
        return keys;
      };
    },
    getTableNum() {
      const length = this.details.athleteList?this.details.athleteList.length:0;
      let num = 0;
      if (length > 18) {
        if(parseFloat(length / 18) > parseInt(length / 18)) {
          num = parseInt(length / 18) + 1;
        }
        else num = parseInt(length / 18);
      }
      else if(length > 0 && length <= 18) {
        num = 1;
      }
      return num;
    }
  },
  mounted() {
    this.getCoachLists();
    this.getYearLists(this.query, this.getMatch);
  },
  methods: {
    // 打印
    print() {
      this.$nextTick(() => {
        this.isShowBottom = true;
        var el = document.querySelector("#prints"),
          iframe = document.createElement("IFRAME"),
          doc = null;
        iframe.setAttribute("id", "print-iframe");
        iframe.setAttribute(
          "style",
          "width:100%;font-size:20px;text-align:center"
        );
        document.body.appendChild(iframe);
        doc = iframe.contentWindow.document;
        doc.write(
          '<html><head><style type="text/css" media="print">ul{list-style:none} @page {size: auto; margin: 0mm 5mm;} .athlete_name {font-size:14px!important} .athlete_regist_number{font-size:12px!important } .border_bottom {border-bottom:1px solid #999!important} .border_top {border-top:1px solid #999!important} .border_right {border-right:1px solid #999!important} .border_left {border-left:1px solid #999!important} .margin_top {margin-top:20mm!important} .match_title {margin:10mm 0 20px;text-align:center;font-size:22px;font-family:PF;font-weight:bold;} .athletes_photo header h2 {margin:0;padding:0} .athletes_photo header h1 {font-size:24px;margin:0 0 14px} .athletes_photo {margin:10px 0 0 0!important} .athletes_photo header {text-align: center;padding: 44px 0;margin:0;color: #444;font-weight: 600;} .big_title {font-size: 14px;}.small_title {font-size: 12px;} table {border:1px solid #999!important} table thead .ths p {margin:0;padding:0} table thead .ths {height: 40px;box-sizing: border-box;vertical-align: middle;font-size:14px!important;border-right:2px solid #999} table tbody td .cell {color:#000} table tbody td {padding: 8px 2px;font-size: 13px;vertical-align: middle;border-top: 1px solid #999;border-right:1px solid #999} .head_title {font-size: 18px;color: #444;font-family: pfSem;padding:0;margin:0;} .fonts_color {color:#000} .athlete_infos {padding:10px 5px!important} .info_text {word-break:break-all} .page_break {margin-top:15mm!important} .phones {width:230px!important} .info_row {margin:0 0 15px 0} .foots {margin-top:20px} .info {margin-bottom:20px} table {margin-top:20px}  main {margin:15mm 0} h1 { margin:5mm 0 40px 0;font-size:24px;text-align:center } span.rights {width:560px}</style></head><body style="zoom: 80%;">' +
            el.innerHTML +
            "</body></html>"
        );
        doc.close();
        iframe.contentWindow.focus();
        iframe.onload = function() {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
        };
      });
    },
    // 报名列表与照片墙切换
    selectType(switchType) {
      this.switchType = switchType;
    },
    // 获取赛事列表
    getMatch() {
      getSignListBySchool({
        project: 2,
        year: this.$route.query.year ? this.$route.query.year : this.query.year
      })
        .then(res => {
          if (res.length > 0) {
            this.matchList = res;
            let id = res[0].id;
            if (this.$route.query.id) {
              res.filter(item => {
                if (item.matchId === this.$route.query.id) id = item.id;
              });
            }
            this.query.matchName = id;
            this.isShowBtn = true;
            this.getSignDetail(id);
          } else {
            this.matchList = [];
            this.query.matchName = "";
            this.isShowData = false;
            this.details = {};
          }
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowBtn = false;
          }
        });
    },
    // 获取详情数据
    getSignDetail(id) {
      signDetail({ project: 2, id })
        .then(res => {
          if (!res) {
            res = { matchName: "" };
          }
          this.matchList.filter(item => {
            if (item.id == id) this.currentProject = item;
          });
          this.details = { ...res };
          this.selectType(this.switchType);
          this.isShowData = true;
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowData = false;
          }
        });
    },
    // 前往提交
    moveSubmit() {
      let id = null;
      this.matchList.filter(item => {
        if (item.id === this.query.matchName) id = item.matchId;
      });
      this.$router.push({
        path: "/martial/martial-application-form",
        query: {
          id
        }
      });
    },
    // 获取教练员列表
    getCoachLists() {
      getCoachList({})
        .then(res => {
          this.coachList = [...res];
        })
        .catch(err => {});
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/font/pfSembold.css";
@import "../../assets/font/pf.css";
.registration_form_view {
  .query_wapper {
    margin-bottom: 20px;
  }
  .head_title {
    font-size: 18px;
    color: #444;
    font-family: pfSem;
  }
  .select {
    background: #1e63b0;
    color: #fff;
  }
  .normal {
    background: transparent;
    color: #999;
  }
  .big_title {
    font-size: 15px;
  }
  .small_title {
    font-size: 12px;
  }
  table {
    thead {
      .ths {
        background: #eee;
        height: 40px;
        box-sizing: border-box;
        vertical-align: middle;
        &:not(:last-of-type) {
          border-right: 1px solid #ddd;
        }
      }
    }
    tbody {
      td {
        padding: 8px 2px;
        font-size: 14px;
        vertical-align: middle;
        border-top: 1px solid #ddd;
        &:not(:last-of-type) {
          border-right: 1px solid #ddd;
        }
      }
    }
  }
  #prints {
    position: absolute;
    left: -100000px;
    top: -100000px;
    opacity: 0;
  }
}
</style>